// Module
var code = "<template> <div dt-grid-container> <h1>Legg til batch</h1> <require from=\"./batch-create-form\"></require> <batch-create-form batch-saved.delegate=\"batchSaved()\"> <a dt-button route-href=\"route: batch-index\">Tilbake til liste</a> </batch-create-form> </div> </template> ";
// Exports
export default code;